export const AUTH_REDIRECT_KEY = 'auth_redirect';
